var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "sub_tit mt25" }, [
      _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.BASIC.INFO")))
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "create_table" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("tbody", [
        _c("tr", [
          _c("th", [
            _vm._v(
              "\n                        " +
                _vm._s(_vm.$t("FIELD.FAQ.CORP")) +
                "\n                        "
            ),
            _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("td", { attrs: { "data-input-type": "select" } }, [
            _c("fieldset", { staticClass: "ui_fieldset set_2" }, [
              _c("div", [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.rhqCd,
                        expression: "rhqCd"
                      }
                    ],
                    staticClass: "slt_white w100p",
                    attrs: { disabled: _vm.viewMode },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.rhqCd = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function($event) {
                          return _vm.changeRhqCd()
                        }
                      ]
                    }
                  },
                  [
                    _c("option", { attrs: { value: "", selected: "" } }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.rhqCdList, function(code) {
                      return _c(
                        "option",
                        { key: code.code, domProps: { value: code.code } },
                        [_vm._v(_vm._s(code.codeName))]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.corpNo,
                        expression: "corpNo"
                      }
                    ],
                    staticClass: "slt_white w100p",
                    attrs: { disabled: _vm.viewMode },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.corpNo = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "", selected: "" } }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.corpNoList, function(code) {
                      return _c(
                        "option",
                        { key: code.code, domProps: { value: code.code } },
                        [_vm._v(_vm._s(code.codeName))]
                      )
                    })
                  ],
                  2
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("th", [
            _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ID"))),
            _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("td", [
            _c("span", { staticClass: "clearable" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.authId,
                    expression: "authId"
                  },
                  { name: "clearable", rawName: "v-clearable" }
                ],
                ref: "authId",
                staticClass: "text_input w100",
                attrs: {
                  type: "text",
                  disabled: _vm.viewMode,
                  maxlength: "20"
                },
                domProps: { value: _vm.authId },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.authId = $event.target.value
                  }
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ROLE.NAME"))),
            _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("td", { attrs: { colspan: "3" } }, [
            _c("span", { staticClass: "clearable" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.authNm,
                    expression: "authNm"
                  },
                  { name: "clearable", rawName: "v-clearable" }
                ],
                ref: "authNm",
                staticClass: "text_input w100",
                attrs: { type: "text", maxlength: "166" },
                domProps: { value: _vm.authNm },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.authNm = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("i", { staticClass: "clearable_clear" }, [_vm._v("X")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v(_vm._s(_vm.$t("SUBTITLE.GLOBAL.DESCRIPTION")))]),
          _vm._v(" "),
          _c("td", { attrs: { colspan: "3" } }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.authDesc,
                  expression: "authDesc"
                }
              ],
              staticClass: "text_textarea w100",
              attrs: { maxlength: "1300" },
              domProps: { value: _vm.authDesc },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.authDesc = $event.target.value
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _vm._v(
              "\n                        " +
                _vm._s(_vm.$t("FIELD.GLOBAL.USE.STATUS")) +
                "\n                        "
            ),
            _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("td", { attrs: { colspan: "3" } }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.useYn,
                    expression: "useYn"
                  }
                ],
                staticClass: "slt_white input-58",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.useYn = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "Y", selected: "" } }, [
                  _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.YES")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "N" } }, [
                  _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.NO")))
                ])
              ]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn_wrap_full topLine" }, [
      !_vm.viewMode
        ? _c(
            "a",
            {
              staticClass: "btn_white",
              attrs: { href: "JavaScript:", title: "" },
              on: {
                click: function($event) {
                  return _vm.goRoleList()
                }
              }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("BUTTON.GLOBAL.LIST")) +
                  "\n            "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      this.sysAdmYn == "Y"
        ? _c("div", { staticClass: "btn_right" }, [
            _c(
              "a",
              {
                staticClass: "btn_white",
                attrs: { href: "JavaScript:", title: "" },
                on: {
                  click: function($event) {
                    return _vm.roleDelete()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn_blue",
                attrs: { href: "JavaScript:", title: "" },
                on: {
                  click: function($event) {
                    return _vm.roleSave()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SAVE")))]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.viewMode
      ? _c("div", { staticClass: "sub_tit mt25 w100" }, [
          _vm._v(_vm._s(_vm.$t("FIELD.AUTHREQ.AUTH")))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.viewMode
      ? _c("div", { staticClass: "tab_wrap" }, [
          _c("ul", { staticClass: "tab_menu_02 tab_menus" }, [
            _c("li", { class: { on: _vm.tabMode === 1 } }, [
              _c(
                "a",
                {
                  attrs: { href: "JavaScript:" },
                  on: {
                    click: function($event) {
                      return _vm.changeTab(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.MENU")))]
              )
            ]),
            _vm._v(" "),
            _c("li", { class: { on: _vm.tabMode === 2 } }, [
              _c(
                "a",
                {
                  attrs: { href: "JavaScript:" },
                  on: {
                    click: function($event) {
                      return _vm.changeTab(2)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.PRODUCT.CATEGORY")))]
              )
            ]),
            _vm._v(" "),
            _c("li", { class: { on: _vm.tabMode === 3 } }, [
              _c(
                "a",
                {
                  attrs: { href: "JavaScript:" },
                  on: {
                    click: function($event) {
                      return _vm.changeTab(3)
                    }
                  }
                },
                [
                  _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.USER")) + " "),
                  _c("em", [
                    _vm._v(
                      "(" +
                        _vm._s(_vm._f("numberFormat")(_vm.authUsers.length)) +
                        ")"
                    )
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tab_contents_list" }, [
            _vm.tabMode == 1
              ? _c("div", { staticClass: "tab_cont" }, [
                  _c("dl", { staticClass: "tree_wrap noLine pl10" }, [
                    _c("dd", [
                      _c("article", { staticClass: "tree_group" }, [
                        _c(
                          "ul",
                          { staticClass: "tree_list" },
                          _vm._l(_vm.menuAllTrees, function(menu1) {
                            return _c("li", { key: menu1.MENUID }, [
                              menu1.subMenu
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "ico_tree",
                                      attrs: { href: "javascript:" },
                                      on: {
                                        click: function($event) {
                                          return _vm.treeClick(
                                            $event,
                                            menu1.MENUID
                                          )
                                        }
                                      }
                                    },
                                    [_c("span", { staticClass: "sr_only" })]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("label", { staticClass: "checkbox-wrap" }, [
                                _c("input", {
                                  staticClass: "chk",
                                  attrs: {
                                    type: "checkbox",
                                    name:
                                      "menu-" +
                                      menu1.MENUPARENTID +
                                      "-" +
                                      menu1.MENUID
                                  },
                                  domProps: {
                                    value: menu1.MENUID,
                                    checked:
                                      "Y" === menu1.MENUCHECK ? true : false
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.treeMenuChange(
                                        $event,
                                        menu1.MENUID
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("i", { staticClass: "check-icon" }),
                                _vm._v(" "),
                                _c("em", [_vm._v(_vm._s(menu1.MENUNAME))])
                              ]),
                              _vm._v(" "),
                              _c("label", { staticClass: "checkbox-wrap" }, [
                                _vm._v(
                                  "\n                                            (\n                                            "
                                ),
                                _c("input", {
                                  staticClass: "chk",
                                  attrs: {
                                    type: "checkbox",
                                    name:
                                      "read-" +
                                      menu1.MENUPARENTID +
                                      "-" +
                                      menu1.MENUID,
                                    disabled:
                                      "Y" === menu1.MENUCHECK ? false : true
                                  },
                                  domProps: {
                                    value: menu1.MENUID,
                                    checked:
                                      "Y" === menu1.CREATIONCHECK ? true : false
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.treeReadChange(
                                        $event,
                                        menu1.MENUID
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("i", { staticClass: "check-icon" }),
                                _vm._v(" "),
                                _c("em", [
                                  _vm._v(
                                    _vm._s(_vm.$t("FIELD.GLOBAL.CREATION")) +
                                      "}"
                                  )
                                ]),
                                _vm._v(
                                  " )\n                                        "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "tree_sub_list" },
                                _vm._l(menu1.subMenu, function(menu2) {
                                  return _c("li", { key: menu2.MENUID }, [
                                    menu2.subMenu
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "ico_tree",
                                            attrs: { href: "javascript:" },
                                            on: {
                                              click: function($event) {
                                                return _vm.treeClick(
                                                  $event,
                                                  menu2.MENUID
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "sr_only"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { staticClass: "checkbox-wrap" },
                                      [
                                        _c("input", {
                                          staticClass: "chk",
                                          attrs: {
                                            type: "checkbox",
                                            name:
                                              "menu-" +
                                              menu1.MENUPARENTID +
                                              "-" +
                                              menu2.MENUPARENTID +
                                              "-" +
                                              menu2.MENUID
                                          },
                                          domProps: {
                                            value: menu2.MENUID,
                                            checked:
                                              "Y" === menu2.MENUCHECK
                                                ? true
                                                : false
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.treeMenuChange(
                                                $event,
                                                menu2.MENUID
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("i", { staticClass: "check-icon" }),
                                        _vm._v(" "),
                                        _c("em", [
                                          _vm._v(_vm._s(menu2.MENUNAME))
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { staticClass: "checkbox-wrap" },
                                      [
                                        _vm._v(
                                          "\n                                                    (\n                                                    "
                                        ),
                                        _c("input", {
                                          staticClass: "chk",
                                          attrs: {
                                            type: "checkbox",
                                            name:
                                              "read-" +
                                              menu1.MENUPARENTID +
                                              "-" +
                                              menu2.MENUPARENTID +
                                              "-" +
                                              menu2.MENUID,
                                            disabled:
                                              "Y" === menu2.MENUCHECK
                                                ? false
                                                : true
                                          },
                                          domProps: {
                                            value: menu2.MENUID,
                                            checked:
                                              "Y" === menu2.CREATIONCHECK
                                                ? true
                                                : false
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.treeReadChange(
                                                $event,
                                                menu2.MENUID
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("i", { staticClass: "check-icon" }),
                                        _vm._v(" "),
                                        _c("em", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("FIELD.GLOBAL.CREATION")
                                            )
                                          )
                                        ]),
                                        _vm._v(
                                          " )\n                                                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "tree_sub_list" },
                                      _vm._l(menu2.subMenu, function(menu3) {
                                        return _c("li", { key: menu3.MENUID }, [
                                          menu3.subMenu
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass: "ico_tree",
                                                  attrs: {
                                                    href: "javascript:"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.treeClick(
                                                        $event,
                                                        menu3.MENUID
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass: "sr_only"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { staticClass: "checkbox-wrap" },
                                            [
                                              _c("input", {
                                                staticClass: "chk",
                                                attrs: {
                                                  type: "checkbox",
                                                  name:
                                                    "menu-" +
                                                    menu1.MENUPARENTID +
                                                    "-" +
                                                    menu2.MENUPARENTID +
                                                    "-" +
                                                    menu3.MENUPARENTID +
                                                    "-" +
                                                    menu3.MENUID
                                                },
                                                domProps: {
                                                  value: menu3.MENUID,
                                                  checked:
                                                    "Y" === menu3.MENUCHECK
                                                      ? true
                                                      : false
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.treeMenuChange(
                                                      $event,
                                                      menu3.MENUID
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "check-icon"
                                              }),
                                              _vm._v(" "),
                                              _c("em", [
                                                _vm._v(_vm._s(menu3.MENUNAME))
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { staticClass: "checkbox-wrap" },
                                            [
                                              _vm._v(
                                                "\n                                                            (\n                                                            "
                                              ),
                                              _c("input", {
                                                staticClass: "chk",
                                                attrs: {
                                                  type: "checkbox",
                                                  name:
                                                    "read-" +
                                                    menu1.MENUPARENTID +
                                                    "-" +
                                                    menu2.MENUPARENTID +
                                                    "-" +
                                                    menu3.MENUPARENTID +
                                                    "-" +
                                                    menu3.MENUID,
                                                  disabled:
                                                    "Y" === menu3.MENUCHECK
                                                      ? false
                                                      : true
                                                },
                                                domProps: {
                                                  value: menu3.MENUID,
                                                  checked:
                                                    "Y" === menu3.CREATIONCHECK
                                                      ? true
                                                      : false
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.treeReadChange(
                                                      $event,
                                                      menu3.MENUID
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("i", {
                                                staticClass: "check-icon"
                                              }),
                                              _vm._v(" "),
                                              _c("em", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "FIELD.GLOBAL.CREATION"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(
                                                " )\n                                                        "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "ul",
                                            { staticClass: "tree_sub_list" },
                                            _vm._l(menu3.subMenu, function(
                                              menu4
                                            ) {
                                              return _c(
                                                "li",
                                                { key: menu4.MENUID },
                                                [
                                                  menu4.subMenu
                                                    ? _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "ico_tree",
                                                          attrs: {
                                                            href: "javascript:"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.treeClick(
                                                                $event,
                                                                menu4.MENUID
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "sr_only"
                                                          })
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "checkbox-wrap"
                                                    },
                                                    [
                                                      _c("input", {
                                                        staticClass: "chk",
                                                        attrs: {
                                                          type: "checkbox",
                                                          name:
                                                            "menu-" +
                                                            menu1.MENUPARENTID +
                                                            "-" +
                                                            menu2.MENUPARENTID +
                                                            "-" +
                                                            menu3.MENUPARENTID +
                                                            "-" +
                                                            menu4.MENUPARENTID +
                                                            "-" +
                                                            menu4.MENUID
                                                        },
                                                        domProps: {
                                                          value: menu4.MENUID,
                                                          checked:
                                                            "Y" ===
                                                            menu4.MENUCHECK
                                                              ? true
                                                              : false
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.treeMenuChange(
                                                              $event,
                                                              menu4.MENUID
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("i", {
                                                        staticClass:
                                                          "check-icon"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("em", [
                                                        _vm._v(
                                                          _vm._s(menu4.MENUNAME)
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "checkbox-wrap"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                                    (\n                                                                    "
                                                      ),
                                                      _c("input", {
                                                        staticClass: "chk",
                                                        attrs: {
                                                          type: "checkbox",
                                                          name:
                                                            "read-" +
                                                            menu1.MENUPARENTID +
                                                            "-" +
                                                            menu2.MENUPARENTID +
                                                            "-" +
                                                            menu3.MENUPARENTID +
                                                            "-" +
                                                            menu4.MENUPARENTID +
                                                            "-" +
                                                            menu4.MENUID,
                                                          disabled:
                                                            "Y" ===
                                                            menu4.MENUCHECK
                                                              ? false
                                                              : true
                                                        },
                                                        domProps: {
                                                          value: menu4.MENUID,
                                                          checked:
                                                            "Y" ===
                                                            menu4.CREATIONCHECK
                                                              ? true
                                                              : false
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.treeReadChange(
                                                              $event,
                                                              menu4.MENUID
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("i", {
                                                        staticClass:
                                                          "check-icon"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("em", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "FIELD.GLOBAL.CREATION"
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(
                                                        " )\n                                                                "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "ul",
                                                    {
                                                      staticClass:
                                                        "tree_sub_list"
                                                    },
                                                    _vm._l(
                                                      menu4.subMenu,
                                                      function(menu5) {
                                                        return _c(
                                                          "li",
                                                          { key: menu5.MENUID },
                                                          [
                                                            menu5.subMenu
                                                              ? _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "ico_tree",
                                                                    attrs: {
                                                                      href:
                                                                        "javascript:"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.treeClick(
                                                                          $event,
                                                                          menu5.MENUID
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("span", {
                                                                      staticClass:
                                                                        "sr_only"
                                                                    })
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "checkbox-wrap"
                                                              },
                                                              [
                                                                _c("input", {
                                                                  staticClass:
                                                                    "chk",
                                                                  attrs: {
                                                                    type:
                                                                      "checkbox",
                                                                    name:
                                                                      "menu-" +
                                                                      menu1.MENUPARENTID +
                                                                      "-" +
                                                                      menu2.MENUPARENTID +
                                                                      "-" +
                                                                      menu3.MENUPARENTID +
                                                                      "-" +
                                                                      menu4.MENUPARENTID +
                                                                      "-" +
                                                                      menu5.MENUPARENTID +
                                                                      "-" +
                                                                      menu5.MENUID
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      menu5.MENUID,
                                                                    checked:
                                                                      "Y" ===
                                                                      menu5.MENUCHECK
                                                                        ? true
                                                                        : false
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.treeMenuChange(
                                                                        $event,
                                                                        menu5.MENUID
                                                                      )
                                                                    }
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c("i", {
                                                                  staticClass:
                                                                    "check-icon"
                                                                }),
                                                                _vm._v(" "),
                                                                _c("em", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      menu5.MENUNAME
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "checkbox-wrap"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                                            (\n                                                                            "
                                                                ),
                                                                _c("input", {
                                                                  staticClass:
                                                                    "chk",
                                                                  attrs: {
                                                                    type:
                                                                      "checkbox",
                                                                    name:
                                                                      "read-" +
                                                                      menu1.MENUPARENTID +
                                                                      "-" +
                                                                      menu2.MENUPARENTID +
                                                                      "-" +
                                                                      menu3.MENUPARENTID +
                                                                      "-" +
                                                                      menu4.MENUPARENTID +
                                                                      "-" +
                                                                      menu5.MENUPARENTID +
                                                                      "-" +
                                                                      menu5.MENUID,
                                                                    disabled:
                                                                      "Y" ===
                                                                      menu5.MENUCHECK
                                                                        ? false
                                                                        : true
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      menu5.MENUID,
                                                                    checked:
                                                                      "Y" ===
                                                                      menu5.CREATIONCHECK
                                                                        ? true
                                                                        : false
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.treeReadChange(
                                                                        $event,
                                                                        menu5.MENUID
                                                                      )
                                                                    }
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c("i", {
                                                                  staticClass:
                                                                    "check-icon"
                                                                }),
                                                                _vm._v(" "),
                                                                _c("em", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "FIELD.GLOBAL.CREATION"
                                                                      )
                                                                    ) + "}"
                                                                  )
                                                                ]),
                                                                _vm._v(
                                                                  "\n                                                                            )\n                                                                        "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ])
                                      }),
                                      0
                                    )
                                  ])
                                }),
                                0
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "btn_wrap_full topLine" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn_white",
                        attrs: { href: "JavaScript:", title: "" },
                        on: {
                          click: function($event) {
                            return _vm.goRoleList()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("BUTTON.GLOBAL.LIST")) +
                            "\n                        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    this.sysAdmYn == "Y"
                      ? _c("div", { staticClass: "btn_right" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn_blue",
                              attrs: { href: "JavaScript:", title: "" },
                              on: {
                                click: function($event) {
                                  return _vm.menuSave()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("BUTTON.GLOBAL.SAVE")) +
                                  "\n                            "
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabMode == 2
              ? _c("div", { staticClass: "tab_cont" }, [
                  _c("table", { staticClass: "scroll_table" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("thead", [
                      _c("th", { attrs: { width: "7%" } }, [
                        _c("label", { staticClass: "checkbox-wrap" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectAllCate,
                                expression: "selectAllCate"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.selectAllCate)
                                ? _vm._i(_vm.selectAllCate, null) > -1
                                : _vm.selectAllCate
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.selectAllCate,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.selectAllCate = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.selectAllCate = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.selectAllCate = $$c
                                  }
                                },
                                function($event) {
                                  return _vm.checkAllCate()
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c("i", { staticClass: "check-icon" })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("th", { attrs: { width: "25%" } }, [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DEPTH1")))
                      ]),
                      _vm._v(" "),
                      _c("th", { attrs: { width: "25%" } }, [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DEPTH2")))
                      ]),
                      _vm._v(" "),
                      _c("th", { attrs: { width: "*" } }, [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DEPTH3")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.categories, function(item) {
                        return _c("tr", { key: item.CATEGORYID }, [
                          _c(
                            "td",
                            { staticClass: "tC", attrs: { width: "7%" } },
                            [
                              _c("label", { staticClass: "checkbox-wrap" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.selected,
                                      expression: "item.selected"
                                    }
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(item.selected)
                                      ? _vm._i(item.selected, null) > -1
                                      : item.selected
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = item.selected,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              item,
                                              "selected",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              item,
                                              "selected",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(item, "selected", $$c)
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("i", { staticClass: "check-icon" })
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "tC", attrs: { width: "25%" } },
                            [_vm._v(_vm._s(item.PRDCATEGORY1NAME))]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "tC", attrs: { width: "25%" } },
                            [_vm._v(_vm._s(item.PRDCATEGORY2NAME))]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "tC", attrs: { width: "*" } },
                            [_vm._v(_vm._s(item.PRDCATEGORY3NAME))]
                          )
                        ])
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "btn_wrap_full" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn_white",
                        attrs: { href: "JavaScript:", title: "" },
                        on: {
                          click: function($event) {
                            return _vm.goRoleList()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("BUTTON.GLOBAL.LIST")) +
                            "\n                        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn_right" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn_white",
                          attrs: { href: "JavaScript:", title: "" },
                          on: {
                            click: function($event) {
                              return _vm.cateDelete()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")) +
                              "\n                            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn_blue",
                          attrs: { href: "JavaScript:", title: "" },
                          on: {
                            click: function($event) {
                              return _vm.cateAdd()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("BUTTON.GLOBAL.ADD")) +
                              "\n                            "
                          )
                        ]
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.tabMode == 3
              ? _c("div", { staticClass: "tab_cont" }, [
                  _c(
                    "div",
                    { staticClass: "grid_wrap mt-10" },
                    [
                      _c("toast-grid", {
                        key: _vm.gridKey,
                        ref: _vm.gridId,
                        attrs: {
                          gridId: _vm.gridId,
                          columns: _vm.columns,
                          data: _vm.authUsers,
                          options: _vm.options,
                          pageOptions: _vm.pageOptions,
                          isTotalCount: false,
                          click: _vm.contentClick
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "btn_wrap_full" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn_white",
                        attrs: { href: "JavaScript:", title: "" },
                        on: {
                          click: function($event) {
                            return _vm.goRoleList()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("BUTTON.GLOBAL.LIST")) +
                            "\n                        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn_right" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn_white",
                          attrs: { href: "JavaScript:", title: "" },
                          on: {
                            click: function($event) {
                              return _vm.userDelete()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")) +
                              "\n                            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn_blue",
                          attrs: { href: "JavaScript:", title: "" },
                          on: {
                            click: function($event) {
                              return _vm.userAdd()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.$t("BUTTON.GLOBAL.ADD")) +
                              "\n                            "
                          )
                        ]
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "7%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "25%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d565c640", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d565c640","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/system/userRole/RoleAdminView.vue
// module id = mmZn
// module chunks = 0